import { useNavigate } from "react-router-dom";
import Button from "../../../../components/Buttons/Button";
import CustomModal from "../../../../components/Modal/CustomModal";

const FindStoreModal = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="점포 선택"
    >
      <p className="mb-6 text-2xl font-semibold text-center">
        내주변 매장 찾기
      </p>
      <p className="mb-10 text-lg font-medium text-center text-neutral-400">
        서비스 이용을 위해 <br /> 점포를 선택해주세요.
      </p>
      <div className="flex gap-2">
        <form method="dialog" className="w-full">
          <Button size="sm" cancle onClick={() => onRequestClose()}>
            취소
          </Button>
        </form>
        <Button size="sm" onClick={() => navigate("/map")}>
          찾기
        </Button>
      </div>
    </CustomModal>
  );
};

export default FindStoreModal;
